import { render, staticRenderFns } from "./GenerateAccessToken.vue?vue&type=template&id=630e5938"
import script from "./GenerateAccessToken.vue?vue&type=script&lang=js"
export * from "./GenerateAccessToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports